import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  containerCss='container-fluid';
  pageFooter = 'virtue-footer foot';
  footerHTML :string ='';
  logoURL : string = 'mse'

  constructor(private location : Location) { }

  ngOnInit() {

    this.footerHTML = `	
		</div><div class="col-md-12 text-center copy">
		   
		<span>Copyright © ${new Date().getFullYear()} <a href="https://www.virtueanalytics.com/" target="_blank">Virtue Analytics</a> Inc. All Rights Reserved.</span>
           </div>
		`;
  }

}
